@if (model?.data) {
<div class="bg-col-w height-100">
    <!-- page image-->
    <div class="ratio-3-2 overflow-hidden">
        <local-shell />
        <img class="rf"
             [image]="model.data?.additional?.story_thumbnail || model.data?.image">
    </div>
    <div class="center m-t-2">
        <!-- page tags -->
        @for (tag of tagCategories; track tag) {
        <div class="bg-col-5 p-r-1 p-l-1 m-t-2 m-l-1 inline-block"
             [style.padding-top.px]="1"
             [style.padding-bottom.px]="1">
            <span class="o1">{{tag.name}}</span>
        </div>
        }
        <!-- page name -->
        <h3 class="h3 m-t m-t-2-s p-l p-r">{{model.data?.name}}</h3>
        <!-- date and read time -->
        <div class="va-m p2 col-11 m-t-1 m-t-2-s">
            <span class="inline-block">{{typeData.date | date: 'MMMM dd, yyyy'}}</span>
            @if (typeData.date && typeData.readingTime) {
            &nbsp;&#124;&nbsp;
            <p class="inline-block">{{typeData.readingTime}}</p>
            <i class="m-l-1 va-m icon-clock inline-block"></i>
            }
        </div>
    </div>
    <!-- button -->
    <href [link]="model.data.url">
        <button type="button"
                class="button-inline m-t m-b m-b-7-s">
            <span class="inline-block p-b-1">{{'Read article' | translate}}</span>
        </button>
    </href>
</div>
}
